module.exports = __webpack_public_path__ + "static/media/caviar.b3d245b9.png";